"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

// POC option C: derive 2-3 follow-up prompts from article titles.
// Production should call an LLM with the conversation context to generate richer suggestions.
function buildSuggestions(articles) {
  var titles = articles.map(function (a) {
    var _a$title;

    return (_a$title = a.title) === null || _a$title === void 0 ? void 0 : _a$title.trim();
  }).filter(function (t) {
    return Boolean(t);
  }).slice(0, 3);
  return titles.map(function (title) {
    return "Tell me more about: ".concat(title);
  });
}

var FollowUpPills = function FollowUpPills(_ref) {
  var articles = _ref.articles,
      disabled = _ref.disabled,
      onSelect = _ref.onSelect;
  var suggestions = buildSuggestions(articles);
  if (suggestions.length === 0) return null;
  return (0, _preact.h)("div", {
    className: "forethought-agent__followups"
  }, (0, _preact.h)("div", {
    className: "forethought-agent__followups-label"
  }, "Try a follow-up"), (0, _preact.h)("div", {
    className: "forethought-agent__followups-row"
  }, suggestions.map(function (s) {
    return (0, _preact.h)("button", {
      key: s,
      type: "button",
      className: "forethought-agent__pill forethought-agent__pill--ghost",
      disabled: disabled,
      onClick: function onClick() {
        return onSelect(s);
      }
    }, s);
  })));
};

var _default = FollowUpPills;
exports.default = _default;